/**
 * Stock alerts as the shell and Stock & lots show them (cross-module §3.7,
 * 02_DESIGN §3.3; XD-01 / XD-02; WP-18, X XWP-15).
 *
 * One payload — `GET /stock/alertes/compteurs` — feeds the topbar entries AND
 * the views strip of Stock & lots, from the same server definitions as the
 * views themselves, so the number in « 14 alertes stock » is, by construction,
 * the `total` of `/stock?vue=alertes` (« the alert count must correspond to
 * the actual result set »):
 *   · alertes stock = the products of the alert set (stock vendable ≤ seuil
 *     d'alerte, rupture included — XD-01);
 *   · expiry is a SEPARATE entry (« 3 lots périmés »), never summed with
 *     products (XD-02, XMD-01-01).
 * The counts are read once, then again only when a `stock` topic event names
 * `stock:alertes` / `stock:lots` (XA-17) or the window regains focus with a
 * stale value — never on a timer.
 */

const num = (v) => {
  const n = Number(v);
  return Number.isFinite(n) && n > 0 ? Math.trunc(n) : 0;
};

/**
 * @param {any} payload `GET /stock/alertes/compteurs` data:
 *   { alertes_stock, lots_perimes, lots_peremption_proche, vues: { tous, alertes, … }, seuils: { per_30, per_90 } }
 * @returns {{ alertesStock: number, lotsPerimes: number, lotsProchesPeremption: number,
 *   vues: Record<string, number>, seuils: Record<string, number> }}
 */
export function resumeCompteurs(payload) {
  const d = payload ?? {};
  const vues = {};
  for (const [k, v] of Object.entries(d.vues ?? {})) vues[k] = num(v);
  const seuils = {};
  for (const [k, v] of Object.entries(d.seuils ?? {})) seuils[k] = num(v);
  return {
    alertesStock: num(d.alertes_stock),
    lotsPerimes: num(d.lots_perimes),
    lotsProchesPeremption: num(d.lots_peremption_proche),
    vues,
    seuils,
  };
}

/** « 14 alertes stock » / « 1 alerte stock ». */
export function alertesStockLabel(n) {
  return `${n} alerte${n > 1 ? "s" : ""} stock`;
}

/** « 3 lots périmés » / « 1 lot périmé ». */
export function lotsPerimesLabel(n) {
  return n > 1 ? `${n} lots périmés` : `${n} lot périmé`;
}
